import { useParams } from "react-router-dom";
import Layout from "../../components/Layout";
import PageHeader from "../../components/PageHeader";
import { CATEGORIES } from "./settingsCategories";
import SettingsProfile from "./settings/SettingsProfile";
import SettingsServices from "./settings/SettingsServices";
import SettingsScheduling from "./settings/SettingsScheduling";
import SettingsQuotes from "./settings/SettingsQuotes";
import SettingsInvoicing from "./settings/SettingsInvoicing";
import SettingsTax from "./settings/SettingsTax";
import SettingsCrew from "./settings/SettingsCrew";
import SettingsMessages from "./settings/SettingsMessages";
import SettingsAccount from "./settings/SettingsAccount";

const PAGES = {
  profile: SettingsProfile, services: SettingsServices, scheduling: SettingsScheduling,
  quotes: SettingsQuotes, invoicing: SettingsInvoicing, tax: SettingsTax,
  crew: SettingsCrew, messages: SettingsMessages, account: SettingsAccount,
};

export default function SettingsCategory() {
  const { cat } = useParams();
  const Page = PAGES[cat];
  const meta = CATEGORIES.find((c) => c.id === cat);
  if (!Page) return <Layout><PageHeader title="Settings" back="/settings" /><p className="text-muted-foreground">Unknown settings category.</p></Layout>;
  return (
    <Layout>
      <PageHeader title={meta.title} back="/settings" />
      <Page />
    </Layout>
  );
}
